import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Over-Avatars" }
const _hoisted_2 = { class: "App-Over-Avatar-One" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "one")
    ]),
    _createElementVNode("span", {
      style: _normalizeStyle({ marginLeft: `${-_ctx.size / 4}px` }),
      class: "App-Over-Avatar-Two"
    }, [
      _renderSlot(_ctx.$slots, "two")
    ], 4)
  ]))
}